module.exports = __webpack_public_path__ + "assets/img/concealtit.1be66f72.png";